import { Injectable } from '@angular/core';

@Injectable()
export class ThemeService {

    constructor() {
        if (this.isSmartSite) {
            // Adds link to the gss stylesheet into the html head for overriding button colors etc.
            let node = document.createElement('link');
            node.href = 'assets/gss.css';
            node.rel = 'stylesheet';
            node.type = 'text/css';
            node.media = 'all';
            console.log("css", node);
            document.getElementsByTagName('head')[0].appendChild(node);
        }
    }

    // returns true if it's a smart site url
    private get isSmartSite(): boolean {
        //return true; // for testing smart site
        return window.location.hostname.toLowerCase().indexOf("smart") >= 0;
    }

    get logoUrl(): string {
        return this.isSmartSite ? "assets/smart.png" : "assets/sdln.JPG";
    }

    get logoAltText(): string {
        return this.isSmartSite ? "SMART" : "SDLN";
    }

    get lightClass(): string {
        return this.isSmartSite ? "theme-smart-light" : "theme-default-light";
    }
    get darkClass(): string {
        return this.isSmartSite ? "theme-smart-dark" : "theme-default-dark";
    }
    get topMenuClass(): string {
        return this.isSmartSite ? "theme-smart-top-menu" : "theme-default-top-menu";
    }
}
